import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id B1337ECC-EF1F-481B-9E75-6A8DB7A01BB9
 * name video
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/video.svg
 * tags
 * - Video / Movie 
 * - Home Automation 
 */
export const VideoIcon = createSvgIcon(<><path d="M17,10.5V7A1,1 0 0,0 16,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16A1,1 0 0,0 17,17V13.5L21,17.5V6.5L17,10.5Z" /></>, 'VideoIcon');
export default VideoIcon